/* tslint:disable */
/* eslint-disable */
/**
 * DigitalOrderForm
 * DigitalOrderForm backend API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: giacomo.stelluti@dev4side.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosInstance, AxiosPromise } from 'axios';
import { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, BaseAPI, RequestArgs, RequiredError } from './base';

export type AuthenticateResultDto = {
	userId: number;
	isAdmin: boolean;
};

export enum LimitationType {
	Customer = 'customer',
	SalesChannel = 'salesChannel',
	Cluster = 'cluster',
	OperatingCountry = 'operatingCountry',
	ResponsabilityArea = 'responsabilityArea',
}

export interface LimitationDto {
	type: LimitationType;
	sapCode: string;
	value: string;
}

export interface LimitationValue {
	type: LimitationType;
	value: string;
}

export interface SalesGroupDto {
	code?: string;
	name?: string;
}

export interface ExportOrderDto {
	idCustomerSapCode: string;
	fullName: string;
	poNumber: string;
	note: string;

	quantityJewels: number;
	quantityWatches: number;
	quantity: number;

	priceNetBillingJewels: number;
	priceSugJewels: number;
	priceTrJewels: number;

	priceNetBillingWatches: number;
	priceSugWatches: number;
	priceTrWatches: number;

	priceNetBillingTotal: number;
	priceSugTotal: number;
	priceTrTotal: number;

	currencyPriceTr: string;
	currencyPriceNet: string;
	currencyPriceSug: string;

	createdAt: string;

	ordersSap: ExportOrderSapDto[];
}

export interface ExportOrderSapDto {
	orderSapCode: string;
	sapOrderMessage: string;

	name: string;
	address: string;
	city: string;
	country: string;
	zipCode: string;

	priceNetBilling: number;
	priceSug: number;
	priceTr: number;

	currencyPriceSug: string;
	currencyPriceNetBilling: string;
	currencyPriceTrBilling: string;

	orderGroups: any[];

	quantity: number;

	productType: string;
	statusOrder: string;

	businessUnitCode: string;
	businessUnit: string;
}

export interface ProductDto {
	id: number;

	idCatCode: string;
	idExhibitionNovelties?: string;

	business?: string;
	businessUnit?: string;
	family?: string;
	gender?: string;
	productTypeCode?: string;

	aestheticLine?: string;
	aestheticLineMarketing?: string;
	aestheticMotifCode?: string;
	signMarketing?: string;

	descriptionShort?: string;
	descriptionShortMarketing?: string;
	descriptionLong?: string;
	descriptionLongMarketing?: string;

	dateOfIntroduction?: string;

	enabled: boolean;
	isLimitedEdition: boolean;
	isMultisize: boolean;

	exhibitionNovelties?: string;

	urlDetail?: string;
	urlGallery?: string;

	productAssests?: {
		order?: number;
		url?: string;
	}[];
}

/**
 * Accept booked for sales info
 * @export
 * @interface AcceptBookedForSales
 */
export interface AcceptBookedForSales {
	/**
	 *
	 * @type {number}
	 * @memberof AcceptBookedForSales
	 */
	customerFacilityId?: number;
	/**
	 *
	 * @type {string}
	 * @memberof AcceptBookedForSales
	 */
	poNumber?: string;
	/**
	 *
	 * @type {string}
	 * @memberof AcceptBookedForSales
	 */
	orderReasonCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof AcceptBookedForSales
	 */
	note?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof AcceptBookedForSales
	 */
	sendToSap?: boolean;
}
/**
 * Represents a booked for sales events summary
 * @export
 * @interface BookedForSalesEventSummary
 */
export interface BookedForSalesEventSummary {
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEventSummary
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesEventSummary
	 */
	name?: string;
}
/**
 * Represents a booked for sales events recap
 * @export
 * @interface BookedForSalesEvents
 */
export interface BookedForSalesEvents {
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesEvents
	 */
	name?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesEvents
	 */
	currentSoldTo?: string;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	itemConfirmed?: number;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	watchesConfirmed?: number;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	jewelryConfirmed?: number;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	itemToBeConfirmed?: number;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	watchesToBeConfirmed?: number;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesEvents
	 */
	jewelryToBeConfirmed?: number;
	/**
	 *
	 * @type {BookedForSalesProductPriceNet}
	 * @memberof BookedForSalesEvents
	 */
	valueItemsConfirmed?: BookedForSalesProductPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductPriceNet}
	 * @memberof BookedForSalesEvents
	 */
	valueWatchesConfirmed?: BookedForSalesProductPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductPriceNet}
	 * @memberof BookedForSalesEvents
	 */
	valueJewelryConfirmed?: BookedForSalesProductPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductLocalPriceNet}
	 * @memberof BookedForSalesEvents
	 */
	localValueItemsConfirmed?: BookedForSalesProductLocalPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductLocalPriceNet}
	 * @memberof BookedForSalesEvents
	 */
	localValueWatchesConfirmed?: BookedForSalesProductLocalPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductLocalPriceNet}
	 * @memberof BookedForSalesEvents
	 */
	localValueJewelryConfirmed?: BookedForSalesProductLocalPriceNet;
}
/**
 * Expiring booked for sales info
 * @export
 * @interface BookedForSalesExpiring
 */
export interface BookedForSalesExpiring {
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesExpiring
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesExpiring
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesExpiring
	 */
	catalogCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesExpiring
	 */
	expirationDate?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesExpiring
	 */
	sapDescription?: string;
}
/**
 * Booked for sales filter
 * @export
 * @interface BookedForSalesFilter
 */
export interface BookedForSalesFilter {
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesFilter
	 */
	eventId?: number;
}
/**
 * BookedForSales Order reason
 * @export
 * @interface BookedForSalesOrderReason
 */
export interface BookedForSalesOrderReason {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesOrderReason
	 */
	code: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesOrderReason
	 */
	description?: string;
}
/**
 * Represents a booked for sale product
 * @export
 * @interface BookedForSalesProduct
 */
export interface BookedForSalesProduct {
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesProduct
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	type?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	catalogCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	sapDescription?: string;
	/**
	 *
	 * @type {BookedForSalesProductPriceNet}
	 * @memberof BookedForSalesProduct
	 */
	priceNet?: BookedForSalesProductPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductPriceRetail}
	 * @memberof BookedForSalesProduct
	 */
	priceRetail?: BookedForSalesProductPriceRetail;
	/**
	 *
	 * @type {BookedForSalesProductLocalPriceNet}
	 * @memberof BookedForSalesProduct
	 */
	localPriceNet?: BookedForSalesProductLocalPriceNet;
	/**
	 *
	 * @type {BookedForSalesProductLocalPriceRetail}
	 * @memberof BookedForSalesProduct
	 */
	localPriceRetail?: BookedForSalesProductLocalPriceRetail;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	showroomDate?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	expirationDate?: string;
	/**
	 *
	 * @type {BookedForSalesProductStatus}
	 * @memberof BookedForSalesProduct
	 */
	status?: BookedForSalesProductStatus;
	/**
	 *
	 * @type {BookedForSalesProductHeroStatus}
	 * @memberof BookedForSalesProduct
	 */
	heroStatus?: BookedForSalesProductHeroStatus;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	shipTo?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	soldTo?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	note?: string;
	/**
	 *
	 * @type {ProductImage}
	 * @memberof BookedForSalesProduct
	 */
	image?: ProductImage;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	sentAt?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	reasonWhyCancel?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	orderReason?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	orderSapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProduct
	 */
	orderStatus?: string;
}
/**
 *
 * @export
 * @interface BookedForSalesProductHeroStatus
 */
export interface BookedForSalesProductHeroStatus {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductHeroStatus
	 */
	code?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductHeroStatus
	 */
	description?: string;
}
/**
 *
 * @export
 * @interface BookedForSalesProductLocalPriceNet
 */
export interface BookedForSalesProductLocalPriceNet {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductLocalPriceNet
	 */
	currency?: string;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesProductLocalPriceNet
	 */
	amount?: number;
}
/**
 *
 * @export
 * @interface BookedForSalesProductLocalPriceRetail
 */
export interface BookedForSalesProductLocalPriceRetail {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductLocalPriceRetail
	 */
	currency?: string;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesProductLocalPriceRetail
	 */
	amount?: number;
}
/**
 *
 * @export
 * @interface BookedForSalesProductPriceNet
 */
export interface BookedForSalesProductPriceNet {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductPriceNet
	 */
	currency?: string;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesProductPriceNet
	 */
	amount?: number;
}
/**
 *
 * @export
 * @interface BookedForSalesProductPriceRetail
 */
export interface BookedForSalesProductPriceRetail {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductPriceRetail
	 */
	currency?: string;
	/**
	 *
	 * @type {number}
	 * @memberof BookedForSalesProductPriceRetail
	 */
	amount?: number;
}
/**
 *
 * @export
 * @interface BookedForSalesProductStatus
 */
export interface BookedForSalesProductStatus {
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductStatus
	 */
	code?: string;
	/**
	 *
	 * @type {string}
	 * @memberof BookedForSalesProductStatus
	 */
	description?: string;
}
/**
 * Cancel booked for sales info
 * @export
 * @interface CancelBookedForSales
 */
export interface CancelBookedForSales {
	/**
	 *
	 * @type {string}
	 * @memberof CancelBookedForSales
	 */
	reasonWhyCancel?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CancelBookedForSales
	 */
	note?: string;
}
/**
 * Represents a customer
 * @export
 * @interface Customer
 */
export interface Customer {
	/**
	 *
	 * @type {number}
	 * @memberof Customer
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	fullName?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	salesGroupCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	salesGroup?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	country?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	responsabilityArea?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	group?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	accountGroup?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Customer
	 */
	posAssortment?: string;
	/**
	 *
	 * @type {number}
	 * @memberof Customer
	 */
	draftOrder?: number;
	/**
	 *
	 * @type {Customer}
	 * @memberof Customer
	 */
	eccCustomer?: Customer;
}
/**
 * Represents a customer facility (ship to)
 * @export
 * @interface CustomerFacility
 */
export interface CustomerFacility {
	/**
	 *
	 * @type {number}
	 * @memberof CustomerFacility
	 */
	id?: number;
	/**
	 *
	 * @type {boolean}
	 * @memberof CustomerFacility
	 */
	ecc?: boolean;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacility
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacility
	 */
	name?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacility
	 */
	address?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacility
	 */
	city?: string;
	/**
	 *
	 * @type {CustomerFacilityCountry}
	 * @memberof CustomerFacility
	 */
	country?: CustomerFacilityCountry;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacility
	 */
	zipCode?: string;
	/**
	 *
	 * @type {number}
	 * @memberof CustomerFacility
	 */
	leadTime?: number;
}
/**
 *
 * @export
 * @interface CustomerFacilityCountry
 */
export interface CustomerFacilityCountry {
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacilityCountry
	 */
	code?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerFacilityCountry
	 */
	name?: string;
}
/**
 * Customer filter
 * @export
 * @interface CustomerFilter
 */
export interface CustomerFilter {
	/**
	 *
	 * @type {boolean}
	 * @memberof CustomerFilter
	 */
	bookedForSales?: boolean;
	/**
	 *
	 * @type {number}
	 * @memberof CustomerFilter
	 */
	eventId?: number;
}
/**
 * Represents customer summary informations
 * @export
 * @interface CustomerSummary
 */
export interface CustomerSummary {
	/**
	 *
	 * @type {number}
	 * @memberof CustomerSummary
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerSummary
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerSummary
	 */
	fullName?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerSummary
	 */
	salesGroupCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerSummary
	 */
	salesGroup?: string;
	/**
	 *
	 * @type {string}
	 * @memberof CustomerSummary
	 */
	posAssortment?: string;
	/**
	 *
	 * @type {number}
	 * @memberof CustomerSummary
	 */
	draftOrder?: number;
	/**
	 *
	 * @type {boolean}
	 * @memberof CustomerSummary
	 */
	isEcc?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof CustomerSummary
	 */
	isEccHighEnd?: boolean;
}
/**
 * Response modeled over ASP.NET built-in error type based on https://datatracker.ietf.org/doc/html/rfc7807
 * @export
 * @interface ErrorResult
 */
export interface ErrorResult {
	/**
	 *
	 * @type {string}
	 * @memberof ErrorResult
	 */
	type?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ErrorResult
	 */
	title?: string;
	/**
	 *
	 * @type {number}
	 * @memberof ErrorResult
	 */
	status?: number;
	/**
	 *
	 * @type {string}
	 * @memberof ErrorResult
	 */
	detail?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ErrorResult
	 */
	instance?: string;
}
/**
 * Represents an order
 * @export
 * @interface Order
 */
export interface Order {
	/**
	 *
	 * @type {number}
	 * @memberof Order
	 */
	id?: number;
	/**
	 *
	 * @type {OrderStatus}
	 * @memberof Order
	 */
	status: OrderStatus;
	/**
	 *
	 * @type {OrderReason}
	 * @memberof Order
	 */
	reason?: OrderReason;
	/**
	 *
	 * @type {string}
	 * @memberof Order
	 */
	poNumber?: string;
	/**
	 *
	 * @type {number}
	 * @memberof Order
	 */
	amount?: number;
	/**
	 *
	 * @type {string}
	 * @memberof Order
	 */
	note?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Order
	 */
	loginNameSalesAgent?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Order
	 */
	createdAt?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof Order
	 */
	toBeRepriced?: boolean;
	/**
	 *
	 * @type {OrderCustomer}
	 * @memberof Order
	 */
	customer?: OrderCustomer;
	/**
	 *
	 * @type {Array<OrderProduct>}
	 * @memberof Order
	 */
	products?: Array<OrderProduct>;

	/**
	 *
	 * @type {Array<ImportedProduct>}
	 * @memberof Order
	 */
	importedProducts?: Array<ImportedProduct>;
	/**
	 *
	 * @type {CustomerFacility}
	 * @memberof Order
	 */
	importedProductsFacility?: CustomerFacility;
}

export interface ImportedProduct {
	sapCode?: string;
	qty?: number;
}

/**
 *
 * @export
 * @interface OrderCustomer
 */
export interface OrderCustomer {
	/**
	 *
	 * @type {number}
	 * @memberof OrderCustomer
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof OrderCustomer
	 */
	fullName?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderCustomer
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderCustomer
	 */
	salesGroupCode?: string;
}
/**
 * @type OrderFilter
 * Order filter
 * @export
 */
export type OrderFilter = any;

/**
 * Order product
 * @export
 * @interface OrderProduct
 */
export interface OrderProduct {
	/**
	 *
	 * @type {number}
	 * @memberof OrderProduct
	 */
	rowId?: number;
	/**
	 *
	 * @type {number}
	 * @memberof OrderProduct
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	name?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	imageUrl?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	family?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	businessUnitCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	catalogCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	limitedEditionCode?: string;
	/**
	 *
	 * @type {CustomerFacility}
	 * @memberof OrderProduct
	 */
	facility?: CustomerFacility;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	zipCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderProduct
	 */
	deliveryDate?: string;
	/**
	 *
	 * @type {Array<ProductSize>}
	 * @memberof OrderProduct
	 */
	sizes?: Array<ProductSize>;
}
/**
 *
 * @export
 * @interface OrderReason
 */
export interface OrderReason {
	/**
	 *
	 * @type {string}
	 * @memberof OrderReason
	 */
	code?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderReason
	 */
	description?: string;
}
/**
 * Order repricing result
 * @export
 * @interface OrderRepriceResult
 */
export interface OrderRepriceResult {
	/**
	 *
	 * @type {boolean}
	 * @memberof OrderRepriceResult
	 */
	complete: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof OrderRepriceResult
	 */
	pricesIsChanged: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof OrderRepriceResult
	 */
	pricesMissing: boolean;
}
/**
 * Order Sap
 * @export
 * @interface OrderSap
 */
export interface OrderSap {
	/**
	 *
	 * @type {number}
	 * @memberof OrderSap
	 */
	id?: number;
	/**
	 *
	 * @type {number}
	 * @memberof OrderSap
	 */
	idOrder?: number;
	/**
	 *
	 * @type {OrderStatus}
	 * @memberof OrderSap
	 */
	status?: OrderStatus;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSap
	 */
	sapOrderCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSap
	 */
	sapOrderMessage?: string;
	/**
	 *
	 * @type {Array<OrderProduct>}
	 * @memberof OrderSap
	 */
	products?: Array<OrderProduct>;
	/**
	 *
	 * @type {CustomerFacility}
	 * @memberof OrderSap
	 */
	facility?: CustomerFacility;
}
/**
 *
 * @export
 * @interface OrderStatus
 */
export interface OrderStatus {
	/**
	 *
	 * @type {number}
	 * @memberof OrderStatus
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof OrderStatus
	 */
	code?: string;
}
/**
 * Represents order summary informations
 * @export
 * @interface OrderSummary
 */
export interface OrderSummary {
	/**
	 *
	 * @type {number}
	 * @memberof OrderSummary
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSummary
	 */
	customerName?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSummary
	 */
	status?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSummary
	 */
	createdAt?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSummary
	 */
	createdBy?: string;
	/**
	 *
	 * @type {number}
	 * @memberof OrderSummary
	 */
	amount?: number;
	/**
	 *
	 * @type {string}
	 * @memberof OrderSummary
	 */
	currency?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof OrderSummary
	 */
	repricingInProgress?: boolean;
}
/**
 * Order validation outcomes
 * @export
 * @interface OrderValidation
 */
export interface OrderValidation {
	/**
	 *
	 * @type {Array<OrderValidationInvalidOrderItem>}
	 * @memberof OrderValidation
	 */
	invalidOrderItems?: Array<OrderValidationInvalidOrderItem>;
	/**
	 *
	 * @type {Array<OrderValidationFacilityError>}
	 * @memberof OrderValidation
	 */
	facilityErrors?: Array<OrderValidationFacilityError>;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof OrderValidation
	 */
	errorsValidation?: Array<string>;
	/**
	 *
	 * @type {boolean}
	 * @memberof OrderValidation
	 */
	isValid?: boolean;
}
/**
 *
 * @export
 * @interface OrderValidationFacility
 */
export interface OrderValidationFacility {
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationFacility
	 */
	name?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationFacility
	 */
	address?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationFacility
	 */
	city?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationFacility
	 */
	country?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationFacility
	 */
	zipCode?: string;
}
/**
 *
 * @export
 * @interface OrderValidationFacilityError
 */
export interface OrderValidationFacilityError {
	/**
	 *
	 * @type {OrderValidationFacility}
	 * @memberof OrderValidationFacilityError
	 */
	facility?: OrderValidationFacility;
	/**
	 *
	 * @type {OrderValidationFacility}
	 * @memberof OrderValidationFacilityError
	 */
	facilityOrderItem?: OrderValidationFacility;
	/**
	 *
	 * @type {boolean}
	 * @memberof OrderValidationFacilityError
	 */
	isValid?: boolean;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof OrderValidationFacilityError
	 */
	errorsValidation?: Array<string>;
}
/**
 *
 * @export
 * @interface OrderValidationInvalidOrderItem
 */
export interface OrderValidationInvalidOrderItem {
	/**
	 *
	 * @type {number}
	 * @memberof OrderValidationInvalidOrderItem
	 */
	orderItemId?: number;
	/**
	 *
	 * @type {number}
	 * @memberof OrderValidationInvalidOrderItem
	 */
	rowId?: number;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationInvalidOrderItem
	 */
	businessUnitCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationInvalidOrderItem
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof OrderValidationInvalidOrderItem
	 */
	limitedEditionCode?: string;
}
/**
 * Represents a product
 * @export
 * @interface Product
 */
export interface Product {
	/**
	 *
	 * @type {number}
	 * @memberof Product
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	aestheticMotif?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	businessUnitCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	businessUnit?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	type?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	catalogCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	sapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	gender?: string;
	/**
	 * Watch, Serpenti Tubogas, 35 mm
	 * @type {string}
	 * @memberof Product
	 */
	descrShort?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	descrLong?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	descrShortMarketing?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	descrLongMarketing?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	aestheticLine?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	family?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	business?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof Product
	 */
	isLimitedEdition?: boolean;
	/**
	 *
	 * @type {string}
	 * @memberof Product
	 */
	introductionDate?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof Product
	 */
	isNovelty?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof Product
	 */
	isExhibitionNovelty?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof Product
	 */
	isMultisize?: boolean;
	/**
	 *
	 * @type {ProductImage}
	 * @memberof Product
	 */
	image?: ProductImage;
}
/**
 * Represents a product aesthetic motif
 * @export
 * @interface ProductAestheticMotif
 */
export interface ProductAestheticMotif {
	/**
	 *
	 * @type {string}
	 * @memberof ProductAestheticMotif
	 */
	code?: string;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof ProductAestheticMotif
	 */
	genders?: Array<string>;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof ProductAestheticMotif
	 */
	productTypes?: Array<string>;
}
/**
 * Represents a product attribute
 * @export
 * @interface ProductAttribute
 */
export interface ProductAttribute {
	/**
	 *
	 * @type {string}
	 * @memberof ProductAttribute
	 */
	name?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductAttribute
	 */
	value?: string;
}
/**
 * Represents a product business unit
 * @export
 * @interface ProductBusinessUnit
 */
export interface ProductBusinessUnit {
	/**
	 *
	 * @type {string}
	 * @memberof ProductBusinessUnit
	 */
	code?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductBusinessUnit
	 */
	name?: string;
}
/**
 * Product filter
 * @export
 * @interface ProductFilter
 */
export interface ProductFilter {
	/**
	 *
	 * @type {string}
	 * @memberof ProductFilter
	 */
	businessUnitCode: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductFilter
	 */
	aestheticMotif?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductFilter
	 */
	search?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductFilter
	 */
	productType?: string;
}
/**
 *
 * @export
 * @interface ProductImage
 */
export interface ProductImage {
	/**
	 *
	 * @type {string}
	 * @memberof ProductImage
	 */
	galleryUrl?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductImage
	 */
	detailUrl?: string;
}

/**
 * Represents a product size
 * @export
 * @interface ProductSize
 */
export interface ProductSize {
	/**
	 *
	 * @type {number}
	 * @memberof ProductSize
	 */
	id?: number;
	/**
	 *
	 * @type {ProductDto}
	 * @memberof ProductSize
	 */
	product?: ProductDto;
	/**
	 *
	 * @type {string}
	 * @memberof ProductSize
	 */
	code?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductSize
	 */
	idSapCode?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ProductSize
	 */
	sapCode?: string;
	/**
	 *
	 * @type {number}
	 * @memberof ProductSize
	 */
	orderItemId?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ProductSize
	 */
	quantity?: number;
	/**
	 *
	 * @type {ProductSizePriceNet}
	 * @memberof ProductSize
	 */
	priceNet?: ProductSizePriceNet;
	/**
	 *
	 * @type {ProductSizePriceNet}
	 * @memberof ProductSize
	 */
	priceGross?: ProductSizePriceNet;
}
/**
 *
 * @export
 * @interface ProductSizePriceNet
 */
export interface ProductSizePriceNet {
	/**
	 *
	 * @type {string}
	 * @memberof ProductSizePriceNet
	 */
	currency?: string;
	/**
	 *
	 * @type {number}
	 * @memberof ProductSizePriceNet
	 */
	amount?: number;
}

/**
 * BookedForSalesApi - axios parameter creator
 * @export
 */
export const BookedForSalesApiAxiosParamCreator = function (
	configuration?: Configuration,
) {
	return {
		/**
		 *
		 * @summary Accept booked for sales
		 * @param {number} id BookedForSales ID
		 * @param {AcceptBookedForSales} [acceptBookedForSales]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		acceptBookedForSales: async (
			id: number,
			acceptBookedForSales?: AcceptBookedForSales,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling acceptBookedForSales.',
				);
			}
			const localVarPath = `/bookedForSales/{id}/accept`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof acceptBookedForSales !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(
						acceptBookedForSales !== undefined ? acceptBookedForSales : {},
					)
				: acceptBookedForSales || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Cancel booked for sales
		 * @param {number} id BookedForSales ID
		 * @param {CancelBookedForSales} [cancelBookedForSales]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cancelBookedForSales: async (
			id: number,
			cancelBookedForSales?: CancelBookedForSales,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling cancelBookedForSales.',
				);
			}
			const localVarPath = `/bookedForSales/{id}/cancel`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof cancelBookedForSales !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(
						cancelBookedForSales !== undefined ? cancelBookedForSales : {},
					)
				: cancelBookedForSales || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets booked for sales events
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getBookedForSalesEvents: async (
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/bookedForSales/events`;
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets booked for sales order reasons
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getBookedForSalesOrderReasons: async (
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/bookedForSales/orderreasons/`;
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets booked for sales expiring
		 * @param {number} salesAgentId Sales agent ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getExpiringBookedForSales: async (
			salesAgentId: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'salesAgentId' is not null or undefined
			if (salesAgentId === null || salesAgentId === undefined) {
				throw new RequiredError(
					'salesAgentId',
					'Required parameter salesAgentId was null or undefined when calling getExpiringBookedForSales.',
				);
			}
			const localVarPath = `/bookedForSales/{salesAgentId}/expiring`.replace(
				`{${'salesAgentId'}}`,
				encodeURIComponent(String(salesAgentId)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets a printable version of a bookedForSales order with given ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		printBookedForSalesOrder: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling printBookedForSalesOrder.',
				);
			}
			const localVarPath = `/bookedForSales/{id}/printable`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
	};
};

/**
 * BookedForSalesApi - functional programming interface
 * @export
 */
export const BookedForSalesApiFp = function (configuration?: Configuration) {
	return {
		/**
		 *
		 * @summary Accept booked for sales
		 * @param {number} id BookedForSales ID
		 * @param {AcceptBookedForSales} [acceptBookedForSales]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async acceptBookedForSales(
			id: number,
			acceptBookedForSales?: AcceptBookedForSales,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await BookedForSalesApiAxiosParamCreator(
				configuration,
			).acceptBookedForSales(id, acceptBookedForSales, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Cancel booked for sales
		 * @param {number} id BookedForSales ID
		 * @param {CancelBookedForSales} [cancelBookedForSales]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async cancelBookedForSales(
			id: number,
			cancelBookedForSales?: CancelBookedForSales,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await BookedForSalesApiAxiosParamCreator(
				configuration,
			).cancelBookedForSales(id, cancelBookedForSales, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets booked for sales events
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getBookedForSalesEvents(
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<BookedForSalesEventSummary>>
		> {
			const localVarAxiosArgs =
				await BookedForSalesApiAxiosParamCreator(
					configuration,
				).getBookedForSalesEvents(options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets booked for sales order reasons
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getBookedForSalesOrderReasons(
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<BookedForSalesOrderReason>
		> {
			const localVarAxiosArgs =
				await BookedForSalesApiAxiosParamCreator(
					configuration,
				).getBookedForSalesOrderReasons(options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets booked for sales expiring
		 * @param {number} salesAgentId Sales agent ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getExpiringBookedForSales(
			salesAgentId: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<BookedForSalesExpiring>>
		> {
			const localVarAxiosArgs = await BookedForSalesApiAxiosParamCreator(
				configuration,
			).getExpiringBookedForSales(salesAgentId, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets a printable version of a bookedForSales order with given ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async printBookedForSalesOrder(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
		> {
			const localVarAxiosArgs = await BookedForSalesApiAxiosParamCreator(
				configuration,
			).printBookedForSalesOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
	};
};

/**
 * BookedForSalesApi - factory interface
 * @export
 */
export const BookedForSalesApiFactory = function (
	configuration?: Configuration,
	basePath?: string,
	axios?: AxiosInstance,
) {
	return {
		/**
		 *
		 * @summary Accept booked for sales
		 * @param {number} id BookedForSales ID
		 * @param {AcceptBookedForSales} [acceptBookedForSales]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		acceptBookedForSales(
			id: number,
			acceptBookedForSales?: AcceptBookedForSales,
			options?: any,
		): AxiosPromise<void> {
			return BookedForSalesApiFp(configuration)
				.acceptBookedForSales(id, acceptBookedForSales, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Cancel booked for sales
		 * @param {number} id BookedForSales ID
		 * @param {CancelBookedForSales} [cancelBookedForSales]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cancelBookedForSales(
			id: number,
			cancelBookedForSales?: CancelBookedForSales,
			options?: any,
		): AxiosPromise<void> {
			return BookedForSalesApiFp(configuration)
				.cancelBookedForSales(id, cancelBookedForSales, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets booked for sales events
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getBookedForSalesEvents(
			options?: any,
		): AxiosPromise<Array<BookedForSalesEventSummary>> {
			return BookedForSalesApiFp(configuration)
				.getBookedForSalesEvents(options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets booked for sales order reasons
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getBookedForSalesOrderReasons(
			options?: any,
		): AxiosPromise<BookedForSalesOrderReason> {
			return BookedForSalesApiFp(configuration)
				.getBookedForSalesOrderReasons(options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets booked for sales expiring
		 * @param {number} salesAgentId Sales agent ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getExpiringBookedForSales(
			salesAgentId: number,
			options?: any,
		): AxiosPromise<Array<BookedForSalesExpiring>> {
			return BookedForSalesApiFp(configuration)
				.getExpiringBookedForSales(salesAgentId, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets a printable version of a bookedForSales order with given ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		printBookedForSalesOrder(id: number, options?: any): AxiosPromise<any> {
			return BookedForSalesApiFp(configuration)
				.printBookedForSalesOrder(id, options)
				.then((request) => request(axios, basePath));
		},
	};
};

/**
 * BookedForSalesApi - object-oriented interface
 * @export
 * @class BookedForSalesApi
 * @extends {BaseAPI}
 */
export class BookedForSalesApi extends BaseAPI {
	/**
	 *
	 * @summary Accept booked for sales
	 * @param {number} id BookedForSales ID
	 * @param {AcceptBookedForSales} [acceptBookedForSales]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof BookedForSalesApi
	 */
	public acceptBookedForSales(
		id: number,
		acceptBookedForSales?: AcceptBookedForSales,
		options?: any,
	) {
		return BookedForSalesApiFp(this.configuration)
			.acceptBookedForSales(id, acceptBookedForSales, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Cancel booked for sales
	 * @param {number} id BookedForSales ID
	 * @param {CancelBookedForSales} [cancelBookedForSales]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof BookedForSalesApi
	 */
	public cancelBookedForSales(
		id: number,
		cancelBookedForSales?: CancelBookedForSales,
		options?: any,
	) {
		return BookedForSalesApiFp(this.configuration)
			.cancelBookedForSales(id, cancelBookedForSales, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets booked for sales events
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof BookedForSalesApi
	 */
	public getBookedForSalesEvents(options?: any) {
		return BookedForSalesApiFp(this.configuration)
			.getBookedForSalesEvents(options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets booked for sales order reasons
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof BookedForSalesApi
	 */
	public getBookedForSalesOrderReasons(options?: any) {
		return BookedForSalesApiFp(this.configuration)
			.getBookedForSalesOrderReasons(options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets booked for sales expiring
	 * @param {number} salesAgentId Sales agent ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof BookedForSalesApi
	 */
	public getExpiringBookedForSales(salesAgentId: number, options?: any) {
		return BookedForSalesApiFp(this.configuration)
			.getExpiringBookedForSales(salesAgentId, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets a printable version of a bookedForSales order with given ID
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof BookedForSalesApi
	 */
	public printBookedForSalesOrder(id: number, options?: any) {
		return BookedForSalesApiFp(this.configuration)
			.printBookedForSalesOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}
}

/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (
	configuration?: Configuration,
) {
	return {
		/**
		 *
		 * @summary Get customer by ID
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomer: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomer.',
				);
			}
			const localVarPath = `/customers/{id}`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer booked for sales by filter
		 * @param {number} id Customer ID
		 * @param {BookedForSalesFilter} [bookedForSalesFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerBookedForSalesByFilter: async (
			id: number,
			bookedForSalesFilter?: BookedForSalesFilter,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerBookedForSalesByFilter.',
				);
			}
			const localVarPath = `/customers/{id}/bookedForSales`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof bookedForSalesFilter !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(
						bookedForSalesFilter !== undefined ? bookedForSalesFilter : {},
					)
				: bookedForSalesFilter || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer booked for sales event recap
		 * @param {number} id Customer ID
		 * @param {number} eventId Event ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerBookedForSalesEventRecap: async (
			id: number,
			eventId: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerBookedForSalesEventRecap.',
				);
			}
			// verify required parameter 'eventId' is not null or undefined
			if (eventId === null || eventId === undefined) {
				throw new RequiredError(
					'eventId',
					'Required parameter eventId was null or undefined when calling getCustomerBookedForSalesEventRecap.',
				);
			}
			const localVarPath = `/customers/{id}/bookedForSalesEvents/{eventId}`
				.replace(`{${'id'}}`, encodeURIComponent(String(id)))
				.replace(`{${'eventId'}}`, encodeURIComponent(String(eventId)));
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer business units
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerBusinessUnits: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerBusinessUnits.',
				);
			}
			const localVarPath = `/customers/{id}/products/businessunits`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Get customer facilities (ship to)
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerFacilities: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerFacilities.',
				);
			}
			const localVarPath = `/customers/{id}/facilities`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer product aesthetic motifs by business unit
		 * @param {number} id Customer ID
		 * @param {string} businessUnitCode Business unit code
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductAestheticMotifs: async (
			id: number,
			businessUnitCode: string,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerProductAestheticMotifs.',
				);
			}
			// verify required parameter 'businessUnitCode' is not null or undefined
			if (businessUnitCode === null || businessUnitCode === undefined) {
				throw new RequiredError(
					'businessUnitCode',
					'Required parameter businessUnitCode was null or undefined when calling getCustomerProductAestheticMotifs.',
				);
			}
			const localVarPath =
				`/customers/{id}/products/aestheticmotifs/{businessUnitCode}`
					.replace(`{${'id'}}`, encodeURIComponent(String(id)))
					.replace(
						`{${'businessUnitCode'}}`,
						encodeURIComponent(String(businessUnitCode)),
					);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer product price
		 * @param {number} id Customer ID
		 * @param {number} productId Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductPrice: async (
			id: number,
			productId: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerProductPrice.',
				);
			}
			// verify required parameter 'productId' is not null or undefined
			if (productId === null || productId === undefined) {
				throw new RequiredError(
					'productId',
					'Required parameter productId was null or undefined when calling getCustomerProductPrice.',
				);
			}
			const localVarPath = `/customers/{id}/products/{productId}/price`
				.replace(`{${'id'}}`, encodeURIComponent(String(id)))
				.replace(`{${'productId'}}`, encodeURIComponent(String(productId)));
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer product sizes
		 * @param {number} id Customer ID
		 * @param {number} productId Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductSizes: async (
			id: number,
			productId: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerProductSizes.',
				);
			}
			// verify required parameter 'productId' is not null or undefined
			if (productId === null || productId === undefined) {
				throw new RequiredError(
					'productId',
					'Required parameter productId was null or undefined when calling getCustomerProductSizes.',
				);
			}
			const localVarPath = `/customers/{id}/products/{productId}/sizes`
				.replace(`{${'id'}}`, encodeURIComponent(String(id)))
				.replace(`{${'productId'}}`, encodeURIComponent(String(productId)));
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets customer products by filter
		 * @param {number} id Customer ID
		 * @param {ProductFilter} [productFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductsByFilter: async (
			id: number,
			productFilter?: ProductFilter,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getCustomerProductsByFilter.',
				);
			}
			const localVarPath = `/customers/{id}/products`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof productFilter !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(productFilter !== undefined ? productFilter : {})
				: productFilter || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Get customers summary informations by sales agent
		 * @param {number} salesAgentId Sales agent ID
		 * @param {CustomerFilter} [customerFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomersSummaryBySalesAgent: async (
			salesAgentId: number,
			customerFilter?: CustomerFilter,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'salesAgentId' is not null or undefined
			if (salesAgentId === null || salesAgentId === undefined) {
				throw new RequiredError(
					'salesAgentId',
					'Required parameter salesAgentId was null or undefined when calling getCustomersSummaryBySalesAgent.',
				);
			}
			const localVarPath = `/customers/{salesAgentId}/summary`.replace(
				`{${'salesAgentId'}}`,
				encodeURIComponent(String(salesAgentId)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof customerFilter !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(customerFilter !== undefined ? customerFilter : {})
				: customerFilter || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
	};
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function (configuration?: Configuration) {
	return {
		/**
		 *
		 * @summary Get customer by ID
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomer(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomer(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer booked for sales by filter
		 * @param {number} id Customer ID
		 * @param {BookedForSalesFilter} [bookedForSalesFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerBookedForSalesByFilter(
			id: number,
			bookedForSalesFilter?: BookedForSalesFilter,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<BookedForSalesProduct>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerBookedForSalesByFilter(id, bookedForSalesFilter, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer booked for sales event recap
		 * @param {number} id Customer ID
		 * @param {number} eventId Event ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerBookedForSalesEventRecap(
			id: number,
			eventId: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<BookedForSalesEvents>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerBookedForSalesEventRecap(id, eventId, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer business units
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerBusinessUnits(
			id: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<ProductBusinessUnit>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerBusinessUnits(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Get customer facilities (ship to)
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerFacilities(
			id: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<CustomerFacility>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerFacilities(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer product aesthetic motifs by business unit
		 * @param {number} id Customer ID
		 * @param {string} businessUnitCode Business unit code
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerProductAestheticMotifs(
			id: number,
			businessUnitCode: string,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<ProductAestheticMotif>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerProductAestheticMotifs(id, businessUnitCode, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer product price
		 * @param {number} id Customer ID
		 * @param {number} productId Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerProductPrice(
			id: number,
			productId: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSize>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerProductPrice(id, productId, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer product sizes
		 * @param {number} id Customer ID
		 * @param {number} productId Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerProductSizes(
			id: number,
			productId: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<ProductSize>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerProductSizes(id, productId, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets customer products by filter
		 * @param {number} id Customer ID
		 * @param {ProductFilter} [productFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomerProductsByFilter(
			id: number,
			productFilter?: ProductFilter,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomerProductsByFilter(id, productFilter, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Get customers summary informations by sales agent
		 * @param {number} salesAgentId Sales agent ID
		 * @param {CustomerFilter} [customerFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomersSummaryBySalesAgent(
			salesAgentId: number,
			customerFilter?: CustomerFilter,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<CustomerSummary>>
		> {
			const localVarAxiosArgs = await CustomerApiAxiosParamCreator(
				configuration,
			).getCustomersSummaryBySalesAgent(salesAgentId, customerFilter, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
	};
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (
	configuration?: Configuration,
	basePath?: string,
	axios?: AxiosInstance,
) {
	return {
		/**
		 *
		 * @summary Get customer by ID
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomer(id: number, options?: any): AxiosPromise<Customer> {
			return CustomerApiFp(configuration)
				.getCustomer(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer booked for sales by filter
		 * @param {number} id Customer ID
		 * @param {BookedForSalesFilter} [bookedForSalesFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerBookedForSalesByFilter(
			id: number,
			bookedForSalesFilter?: BookedForSalesFilter,
			options?: any,
		): AxiosPromise<Array<BookedForSalesProduct>> {
			return CustomerApiFp(configuration)
				.getCustomerBookedForSalesByFilter(id, bookedForSalesFilter, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer booked for sales event recap
		 * @param {number} id Customer ID
		 * @param {number} eventId Event ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerBookedForSalesEventRecap(
			id: number,
			eventId: number,
			options?: any,
		): AxiosPromise<BookedForSalesEvents> {
			return CustomerApiFp(configuration)
				.getCustomerBookedForSalesEventRecap(id, eventId, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer business units
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerBusinessUnits(
			id: number,
			options?: any,
		): AxiosPromise<Array<ProductBusinessUnit>> {
			return CustomerApiFp(configuration)
				.getCustomerBusinessUnits(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Get customer facilities (ship to)
		 * @param {number} id Customer ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerFacilities(
			id: number,
			options?: any,
		): AxiosPromise<Array<CustomerFacility>> {
			return CustomerApiFp(configuration)
				.getCustomerFacilities(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer product aesthetic motifs by business unit
		 * @param {number} id Customer ID
		 * @param {string} businessUnitCode Business unit code
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductAestheticMotifs(
			id: number,
			businessUnitCode: string,
			options?: any,
		): AxiosPromise<Array<ProductAestheticMotif>> {
			return CustomerApiFp(configuration)
				.getCustomerProductAestheticMotifs(id, businessUnitCode, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer product price
		 * @param {number} id Customer ID
		 * @param {number} productId Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductPrice(
			id: number,
			productId: number,
			options?: any,
		): AxiosPromise<ProductSize> {
			return CustomerApiFp(configuration)
				.getCustomerProductPrice(id, productId, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer product sizes
		 * @param {number} id Customer ID
		 * @param {number} productId Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductSizes(
			id: number,
			productId: number,
			options?: any,
		): AxiosPromise<Array<ProductSize>> {
			return CustomerApiFp(configuration)
				.getCustomerProductSizes(id, productId, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets customer products by filter
		 * @param {number} id Customer ID
		 * @param {ProductFilter} [productFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomerProductsByFilter(
			id: number,
			productFilter?: ProductFilter,
			options?: any,
		): AxiosPromise<Array<Product>> {
			return CustomerApiFp(configuration)
				.getCustomerProductsByFilter(id, productFilter, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Get customers summary informations by sales agent
		 * @param {number} salesAgentId Sales agent ID
		 * @param {CustomerFilter} [customerFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomersSummaryBySalesAgent(
			salesAgentId: number,
			customerFilter?: CustomerFilter,
			options?: any,
		): AxiosPromise<Array<CustomerSummary>> {
			return CustomerApiFp(configuration)
				.getCustomersSummaryBySalesAgent(salesAgentId, customerFilter, options)
				.then((request) => request(axios, basePath));
		},
	};
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
	/**
	 *
	 * @summary Get customer by ID
	 * @param {number} id Customer ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomer(id: number, options?: any) {
		return CustomerApiFp(this.configuration)
			.getCustomer(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer booked for sales by filter
	 * @param {number} id Customer ID
	 * @param {BookedForSalesFilter} [bookedForSalesFilter]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerBookedForSalesByFilter(
		id: number,
		bookedForSalesFilter?: BookedForSalesFilter,
		options?: any,
	) {
		return CustomerApiFp(this.configuration)
			.getCustomerBookedForSalesByFilter(id, bookedForSalesFilter, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer booked for sales event recap
	 * @param {number} id Customer ID
	 * @param {number} eventId Event ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerBookedForSalesEventRecap(
		id: number,
		eventId: number,
		options?: any,
	) {
		return CustomerApiFp(this.configuration)
			.getCustomerBookedForSalesEventRecap(id, eventId, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer business units
	 * @param {number} id Customer ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerBusinessUnits(id: number, options?: any) {
		return CustomerApiFp(this.configuration)
			.getCustomerBusinessUnits(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get customer facilities (ship to)
	 * @param {number} id Customer ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerFacilities(id: number, options?: any) {
		return CustomerApiFp(this.configuration)
			.getCustomerFacilities(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer product aesthetic motifs by business unit
	 * @param {number} id Customer ID
	 * @param {string} businessUnitCode Business unit code
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerProductAestheticMotifs(
		id: number,
		businessUnitCode: string,
		options?: any,
	) {
		return CustomerApiFp(this.configuration)
			.getCustomerProductAestheticMotifs(id, businessUnitCode, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer product price
	 * @param {number} id Customer ID
	 * @param {number} productId Product ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerProductPrice(id: number, productId: number, options?: any) {
		return CustomerApiFp(this.configuration)
			.getCustomerProductPrice(id, productId, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer product sizes
	 * @param {number} id Customer ID
	 * @param {number} productId Product ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerProductSizes(id: number, productId: number, options?: any) {
		return CustomerApiFp(this.configuration)
			.getCustomerProductSizes(id, productId, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets customer products by filter
	 * @param {number} id Customer ID
	 * @param {ProductFilter} [productFilter]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomerProductsByFilter(
		id: number,
		productFilter?: ProductFilter,
		options?: any,
	) {
		return CustomerApiFp(this.configuration)
			.getCustomerProductsByFilter(id, productFilter, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get customers summary informations by sales agent
	 * @param {number} salesAgentId Sales agent ID
	 * @param {CustomerFilter} [customerFilter]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof CustomerApi
	 */
	public getCustomersSummaryBySalesAgent(
		salesAgentId: number,
		customerFilter?: CustomerFilter,
		options?: any,
	) {
		return CustomerApiFp(this.configuration)
			.getCustomersSummaryBySalesAgent(salesAgentId, customerFilter, options)
			.then((request) => request(this.axios, this.basePath));
	}
}

/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (
	configuration?: Configuration,
) {
	return {
		/**
		 *
		 * @summary Order status
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		alignOrder: async (id: number, options: any = {}): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling alignOrder.',
				);
			}
			const localVarPath = `/orders/{id}/align`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Deletes an order by ID (only if in dradt)
		 * @param {number} id ID of the draft order to be deleted
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		deleteOrder: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling deleteOrder.',
				);
			}
			const localVarPath = `/orders/{id}`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'DELETE',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Order status
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		finalizeOrder: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling finalizeOrder.',
				);
			}
			const localVarPath = `/orders/{id}/finalize`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets an order by ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrder: async (id: number, options: any = {}): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getOrder.',
				);
			}
			const localVarPath = `/orders/{id}`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets order reasons
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrderReasons: async (options: any = {}): Promise<RequestArgs> => {
			const localVarPath = `/orderreasons/`;
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets the orders sap by main order ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrderSap: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getOrderSap.',
				);
			}
			const localVarPath = `/orders/{id}/orderssap`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets orders summary info by filter
		 * @param {OrderFilter} [orderFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrdersSummaryByFilter: async (
			orderFilter?: OrderFilter,
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/orders/summary`;
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof orderFilter !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(orderFilter !== undefined ? orderFilter : {})
				: orderFilter || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets a printable version of an order with given ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		printOrder: async (id: number, options: any = {}): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling printOrder.',
				);
			}
			const localVarPath = `/orders/{id}/printable`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Order reprice
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		repriceOrder: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling repriceOrder.',
				);
			}
			const localVarPath = `/orders/{id}/reprice`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Update order status
		 * @param {number} id Order ID
		 * @param {number} [body]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		updateOrderStatus: async (
			id: number,
			body?: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling updateOrderStatus.',
				);
			}
			const localVarPath = `/orders/{id}/status`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof body !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(body !== undefined ? body : {})
				: body || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Upsert an order draft
		 * @param {Order} [order]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		upsertOrderDraft: async (
			order?: Order,
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/orders`;
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof order !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(order !== undefined ? order : {})
				: order || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Validate Order
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		validateOrder: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling validateOrder.',
				);
			}
			const localVarPath = `/orders/{id}/validate`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
	};
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function (configuration?: Configuration) {
	return {
		/**
		 *
		 * @summary Order status
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async alignOrder(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).alignOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Deletes an order by ID (only if in dradt)
		 * @param {number} id ID of the draft order to be deleted
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async deleteOrder(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).deleteOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Order status
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async finalizeOrder(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).finalizeOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets an order by ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getOrder(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).getOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets order reasons
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getOrderReasons(
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderReason[]>
		> {
			const localVarAxiosArgs =
				await OrderApiAxiosParamCreator(configuration).getOrderReasons(options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets the orders sap by main order ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getOrderSap(
			id: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<OrderSap>>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).getOrderSap(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets orders summary info by filter
		 * @param {OrderFilter} [orderFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getOrdersSummaryByFilter(
			orderFilter?: OrderFilter,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<OrderSummary>>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).getOrdersSummaryByFilter(orderFilter, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets a printable version of an order with given ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async printOrder(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).printOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Order reprice
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async repriceOrder(
			id: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<OrderRepriceResult>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).repriceOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Update order status
		 * @param {number} id Order ID
		 * @param {number} [body]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async updateOrderStatus(
			id: number,
			body?: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).updateOrderStatus(id, body, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Upsert an order draft
		 * @param {Order} [order]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async upsertOrderDraft(
			order?: Order,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).upsertOrderDraft(order, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Validate Order
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async validateOrder(
			id: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<OrderValidation>
		> {
			const localVarAxiosArgs = await OrderApiAxiosParamCreator(
				configuration,
			).validateOrder(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
	};
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (
	configuration?: Configuration,
	basePath?: string,
	axios?: AxiosInstance,
) {
	return {
		/**
		 *
		 * @summary Order status
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		alignOrder(id: number, options?: any): AxiosPromise<boolean> {
			return OrderApiFp(configuration)
				.alignOrder(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Deletes an order by ID (only if in dradt)
		 * @param {number} id ID of the draft order to be deleted
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		deleteOrder(id: number, options?: any): AxiosPromise<void> {
			return OrderApiFp(configuration)
				.deleteOrder(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Order status
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		finalizeOrder(id: number, options?: any): AxiosPromise<boolean> {
			return OrderApiFp(configuration)
				.finalizeOrder(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets an order by ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrder(id: number, options?: any): AxiosPromise<Order> {
			return OrderApiFp(configuration)
				.getOrder(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets order reasons
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrderReasons(options?: any): AxiosPromise<OrderReason[]> {
			return OrderApiFp(configuration)
				.getOrderReasons(options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets the orders sap by main order ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrderSap(id: number, options?: any): AxiosPromise<Array<OrderSap>> {
			return OrderApiFp(configuration)
				.getOrderSap(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets orders summary info by filter
		 * @param {OrderFilter} [orderFilter]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrdersSummaryByFilter(
			orderFilter?: OrderFilter,
			options?: any,
		): AxiosPromise<Array<OrderSummary>> {
			return OrderApiFp(configuration)
				.getOrdersSummaryByFilter(orderFilter, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets a printable version of an order with given ID
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		printOrder(id: number, options?: any): AxiosPromise<any> {
			return OrderApiFp(configuration)
				.printOrder(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Order reprice
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		repriceOrder(id: number, options?: any): AxiosPromise<OrderRepriceResult> {
			return OrderApiFp(configuration)
				.repriceOrder(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Update order status
		 * @param {number} id Order ID
		 * @param {number} [body]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		updateOrderStatus(
			id: number,
			body?: number,
			options?: any,
		): AxiosPromise<void> {
			return OrderApiFp(configuration)
				.updateOrderStatus(id, body, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Upsert an order draft
		 * @param {Order} [order]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		upsertOrderDraft(order?: Order, options?: any): AxiosPromise<number> {
			return OrderApiFp(configuration)
				.upsertOrderDraft(order, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Validate Order
		 * @param {number} id Order ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		validateOrder(id: number, options?: any): AxiosPromise<OrderValidation> {
			return OrderApiFp(configuration)
				.validateOrder(id, options)
				.then((request) => request(axios, basePath));
		},
	};
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
	/**
	 *
	 * @summary Order status
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public alignOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.alignOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Deletes an order by ID (only if in dradt)
	 * @param {number} id ID of the draft order to be deleted
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public deleteOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.deleteOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Order status
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public finalizeOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.finalizeOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets an order by ID
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public getOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.getOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets order reasons
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public getOrderReasons(options?: any) {
		return OrderApiFp(this.configuration)
			.getOrderReasons(options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets the orders sap by main order ID
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public getOrderSap(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.getOrderSap(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets orders summary info by filter
	 * @param {OrderFilter} [orderFilter]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public getOrdersSummaryByFilter(orderFilter?: OrderFilter, options?: any) {
		return OrderApiFp(this.configuration)
			.getOrdersSummaryByFilter(orderFilter, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets a printable version of an order with given ID
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public printOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.printOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Order reprice
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public repriceOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.repriceOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Update order status
	 * @param {number} id Order ID
	 * @param {number} [body]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public updateOrderStatus(id: number, body?: number, options?: any) {
		return OrderApiFp(this.configuration)
			.updateOrderStatus(id, body, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Upsert an order draft
	 * @param {Order} [order]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public upsertOrderDraft(order?: Order, options?: any) {
		return OrderApiFp(this.configuration)
			.upsertOrderDraft(order, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Validate Order
	 * @param {number} id Order ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof OrderApi
	 */
	public validateOrder(id: number, options?: any) {
		return OrderApiFp(this.configuration)
			.validateOrder(id, options)
			.then((request) => request(this.axios, this.basePath));
	}
}

/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (
	configuration?: Configuration,
) {
	return {
		/**
		 *
		 * @summary Gets product by ID
		 * @param {number} id Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProduct: async (id: number, options: any = {}): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getProduct.',
				);
			}
			const localVarPath = `/products/{id}`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets product attributes
		 * @param {number} id Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProductAttributes: async (
			id: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getProductAttributes.',
				);
			}
			const localVarPath = `/products/{id}/attributes`.replace(
				`{${'id'}}`,
				encodeURIComponent(String(id)),
			);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets first available date for a product by customer facility
		 * @param {number} id Product ID
		 * @param {number} customerFacilityId Customer facility ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProductFirstAvailableDate: async (
			id: number,
			customerFacilityId: number,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError(
					'id',
					'Required parameter id was null or undefined when calling getProductFirstAvailableDate.',
				);
			}
			// verify required parameter 'customerFacilityId' is not null or undefined
			if (customerFacilityId === null || customerFacilityId === undefined) {
				throw new RequiredError(
					'customerFacilityId',
					'Required parameter customerFacilityId was null or undefined when calling getProductFirstAvailableDate.',
				);
			}
			const localVarPath = `/products/{id}/availabledate/{customerFacilityId}`
				.replace(`{${'id'}}`, encodeURIComponent(String(id)))
				.replace(
					`{${'customerFacilityId'}}`,
					encodeURIComponent(String(customerFacilityId)),
				);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Gets first available date for a product list
		 * @param {number} customerFacilityId Customer facility ID
		 * @param {Array<number>} [requestBody]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProductsFirstAvailableDate: async (
			customerFacilityId: number,
			requestBody?: Array<number>,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'customerFacilityId' is not null or undefined
			if (customerFacilityId === null || customerFacilityId === undefined) {
				throw new RequiredError(
					'customerFacilityId',
					'Required parameter customerFacilityId was null or undefined when calling getProductsFirstAvailableDate.',
				);
			}
			const localVarPath =
				`/products/availabledate/{customerFacilityId}`.replace(
					`{${'customerFacilityId'}}`,
					encodeURIComponent(String(customerFacilityId)),
				);
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};
			const nonString = typeof requestBody !== 'string';
			const needsSerialization =
				nonString && configuration && configuration.isJsonMime
					? configuration.isJsonMime(
							localVarRequestOptions.headers['Content-Type'],
						)
					: nonString;
			localVarRequestOptions.data = needsSerialization
				? JSON.stringify(requestBody !== undefined ? requestBody : {})
				: requestBody || '';

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
	};
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function (configuration?: Configuration) {
	return {
		/**
		 *
		 * @summary Gets product by ID
		 * @param {number} id Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getProduct(
			id: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>
		> {
			const localVarAxiosArgs = await ProductApiAxiosParamCreator(
				configuration,
			).getProduct(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets product attributes
		 * @param {number} id Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getProductAttributes(
			id: number,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<Array<ProductAttribute>>
		> {
			const localVarAxiosArgs = await ProductApiAxiosParamCreator(
				configuration,
			).getProductAttributes(id, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets first available date for a product by customer facility
		 * @param {number} id Product ID
		 * @param {number} customerFacilityId Customer facility ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getProductFirstAvailableDate(
			id: number,
			customerFacilityId: number,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
		> {
			const localVarAxiosArgs = await ProductApiAxiosParamCreator(
				configuration,
			).getProductFirstAvailableDate(id, customerFacilityId, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Gets first available date for a product list
		 * @param {number} customerFacilityId Customer facility ID
		 * @param {Array<number>} [requestBody]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getProductsFirstAvailableDate(
			customerFacilityId: number,
			requestBody?: Array<number>,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
		> {
			const localVarAxiosArgs = await ProductApiAxiosParamCreator(
				configuration,
			).getProductsFirstAvailableDate(customerFacilityId, requestBody, options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
	};
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (
	configuration?: Configuration,
	basePath?: string,
	axios?: AxiosInstance,
) {
	return {
		/**
		 *
		 * @summary Gets product by ID
		 * @param {number} id Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProduct(id: number, options?: any): AxiosPromise<Product> {
			return ProductApiFp(configuration)
				.getProduct(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets product attributes
		 * @param {number} id Product ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProductAttributes(
			id: number,
			options?: any,
		): AxiosPromise<Array<ProductAttribute>> {
			return ProductApiFp(configuration)
				.getProductAttributes(id, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets first available date for a product by customer facility
		 * @param {number} id Product ID
		 * @param {number} customerFacilityId Customer facility ID
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProductFirstAvailableDate(
			id: number,
			customerFacilityId: number,
			options?: any,
		): AxiosPromise<string> {
			return ProductApiFp(configuration)
				.getProductFirstAvailableDate(id, customerFacilityId, options)
				.then((request) => request(axios, basePath));
		},
		/**
		 *
		 * @summary Gets first available date for a product list
		 * @param {number} customerFacilityId Customer facility ID
		 * @param {Array<number>} [requestBody]
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProductsFirstAvailableDate(
			customerFacilityId: number,
			requestBody?: Array<number>,
			options?: any,
		): AxiosPromise<string> {
			return ProductApiFp(configuration)
				.getProductsFirstAvailableDate(customerFacilityId, requestBody, options)
				.then((request) => request(axios, basePath));
		},
	};
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
	/**
	 *
	 * @summary Gets product by ID
	 * @param {number} id Product ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ProductApi
	 */
	public getProduct(id: number, options?: any) {
		return ProductApiFp(this.configuration)
			.getProduct(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets product attributes
	 * @param {number} id Product ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ProductApi
	 */
	public getProductAttributes(id: number, options?: any) {
		return ProductApiFp(this.configuration)
			.getProductAttributes(id, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets first available date for a product by customer facility
	 * @param {number} id Product ID
	 * @param {number} customerFacilityId Customer facility ID
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ProductApi
	 */
	public getProductFirstAvailableDate(
		id: number,
		customerFacilityId: number,
		options?: any,
	) {
		return ProductApiFp(this.configuration)
			.getProductFirstAvailableDate(id, customerFacilityId, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Gets first available date for a product list
	 * @param {number} customerFacilityId Customer facility ID
	 * @param {Array<number>} [requestBody]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ProductApi
	 */
	public getProductsFirstAvailableDate(
		customerFacilityId: number,
		requestBody?: Array<number>,
		options?: any,
	) {
		return ProductApiFp(this.configuration)
			.getProductsFirstAvailableDate(customerFacilityId, requestBody, options)
			.then((request) => request(this.axios, this.basePath));
	}
}

/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (
	configuration?: Configuration,
) {
	return {
		/**
		 *
		 * @summary Authenticates a sales agent using AzureAD claims
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authenticate: async (options: any = {}): Promise<RequestArgs> => {
			const localVarPath = `/authenticate`;
			// use dummy base URL string because the URL constructor only accepts absolute URLs.
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');
			let baseOptions;
			if (configuration) {
				baseOptions = configuration.baseOptions;
			}

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			for (const key in options.query) {
				queryParameters.set(key, options.query[key]);
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
			let headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...options.headers,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
	};
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function (configuration?: Configuration) {
	return {
		/**
		 *
		 * @summary Authenticates a sales agent using AzureAD claims
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async authenticate(
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<AuthenticateResultDto>
		> {
			const localVarAxiosArgs =
				await SystemApiAxiosParamCreator(configuration).authenticate(options);
			return (
				axios: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axios.request(axiosRequestArgs);
			};
		},
	};
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (
	configuration?: Configuration,
	basePath?: string,
	axios?: AxiosInstance,
) {
	return {
		/**
		 *
		 * @summary Authenticates a sales agent using AzureAD claims
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authenticate(options?: any): AxiosPromise<AuthenticateResultDto> {
			return SystemApiFp(configuration)
				.authenticate(options)
				.then((request) => request(axios, basePath));
		},
	};
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
	/**
	 *
	 * @summary Authenticates a sales agent using AzureAD claims
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof SystemApi
	 */
	public authenticate(options?: any) {
		return SystemApiFp(this.configuration)
			.authenticate(options)
			.then((request) => request(this.axios, this.basePath));
	}
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (
	configuration?: Configuration,
) {
	return {
		/**
		 *
		 * @summary Import product customer prices from Excel (multipart/form-data)
		 * @param {File | Blob} excelFile Excel file to upload
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		importProductCustomerPrices: async (
			excelFile: File | Blob,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'excelFile' is not null or undefined
			if (excelFile === null || excelFile === undefined) {
				throw new RequiredError(
					'excelFile',
					'Required parameter excelFile was null or undefined when calling importProductCustomerPrices.',
				);
			}

			const localVarPath = `/admin/customerprices/import`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;
			const formData = new FormData();
			formData.append('excelFile', excelFile as any);

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				queryParameters.set(key, localVarQueryParameter[key]);
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			localVarRequestOptions.data = formData;

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Get all products
		 * @param {boolean} [enabled] Optional filter by enabled flag
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getAllProducts: async (
			page: number,
			enabled?: boolean,
			sapCode?: string,
			catalogCode?: string,
			aestheticMotif?: string,
			aestheticLine?: string,
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/admin/products`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;

			const localVarQueryParameter = {
				page,
				enabled,
				sapCode,
				catalogCode,
				aestheticMotif,
				aestheticLine,
			} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Import products from Excel (multipart/form-data)
		 * @param {File | Blob} excelFile Excel file to upload
		 * @param {string} businessUnit watches|jewels
		 * @param {boolean} [skipRemove] optional flag
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		importProducts: async (
			csvFile: File | Blob,
			businessUnit: string,
			skipRemove: boolean = false,
			options: any = {},
		): Promise<RequestArgs> => {
			if (csvFile === null || csvFile === undefined) {
				throw new RequiredError(
					'csvFile',
					'Required parameter excelFile was null or undefined when calling importProducts.',
				);
			}
			if (businessUnit === null || businessUnit === undefined) {
				throw new RequiredError(
					'businessUnit',
					'Required parameter businessUnit was null or undefined when calling importProducts.',
				);
			}

			const localVarPath = `/admin/products/import`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {
				businessUnit,
				skipRemove,
			} as any;

			const formData = new FormData();
			formData.append('csvFile', csvFile as any);

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			localVarRequestOptions.data = formData;

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Get orders by reason code (admin)
		 * @description Retrieves exported orders filtered by the specified reason code.
		 * @param {string} reasonCode Reason code to filter orders
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrdersByReasonCode: async (
			reasonCode: string,
			options: any = {},
		): Promise<RequestArgs> => {
			// verify required parameter 'reasonCode' is not null or undefined
			if (reasonCode === null || reasonCode === undefined) {
				throw new RequiredError(
					'reasonCode',
					'Required parameter reasonCode was null or undefined when calling getOrdersByReasonCode.',
				);
			}

			const localVarPath = `/admin/orders`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {
				reasonCode,
			} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Get all sales groups (admin)
		 * @description Retrieves the list of sales groups available in the system.
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getAllSalesGroups: async (options: any = {}): Promise<RequestArgs> => {
			const localVarPath = `/admin/salesgroups`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Get customers summary by sales group (admin)
		 * @description Retrieves customers summary filtered by salesGroupCode and optional filters.
		 *
		 * IMPORTANT: this backend endpoint is declared as HttpGet but it expects a body (`[FromBody] CustomerFilter filter`).
		 * Many HTTP clients/proxies do not support GET bodies reliably.
		 * This client supports it by sending `data` in axios request options.
		 *
		 * @param {string} salesGroupCode Sales group code
		 * @param {CustomerFilter} filter Filter object (e.g. BookedForSales, EventId)
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomersSummaryBySalesGroup: async (
			salesGroupCode: string,
			filter: CustomerFilter,
			options: any = {},
		): Promise<RequestArgs> => {
			if (salesGroupCode === null || salesGroupCode === undefined) {
				throw new RequiredError(
					'salesGroupCode',
					'Required parameter salesGroupCode was null or undefined when calling getCustomersSummaryBySalesGroup.',
				);
			}
			if (filter === null || filter === undefined) {
				throw new RequiredError(
					'filter',
					'Required parameter filter was null or undefined when calling getCustomersSummaryBySalesGroup.',
				);
			}

			const localVarPath = `/admin/customers/${encodeURIComponent(
				String(salesGroupCode),
			)}/summary`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			// GET with body (axios supports this via `data`)
			localVarRequestOptions.data = filter as any;

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Get expiring booked-for-sales by sales group (admin)
		 * @description Retrieves booked-for-sales expiring items filtered by salesGroupCode.
		 * @param {string} salesGroupCode Sales group code
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getExpiringBookedForSalesBySalesGroup: async (
			salesGroupCode: string,
			options: any = {},
		): Promise<RequestArgs> => {
			if (salesGroupCode === null || salesGroupCode === undefined) {
				throw new RequiredError(
					'salesGroupCode',
					'Required parameter salesGroupCode was null or undefined when calling getExpiringBookedForSalesBySalesGroup.',
				);
			}

			const localVarPath = `/admin/bookedForSales/${encodeURIComponent(
				String(salesGroupCode),
			)}/expiring`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Export orders by reason code (admin)
		 * @description Returns an Excel file (xlsx) for orders filtered by reasonCode.
		 * NOTE: This endpoint returns binary content. Use `responseType: 'blob'` in the request options.
		 * @param {string} reasonCode Reason code to filter orders
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		exportOrdersByReasonCode: async (
			reasonCode: string,
			options: any = {},
		): Promise<RequestArgs> => {
			if (reasonCode === null || reasonCode === undefined) {
				throw new RequiredError(
					'reasonCode',
					'Required parameter reasonCode was null or undefined when calling exportOrdersByReasonCode.',
				);
			}

			const localVarPath = `/admin/orders/export`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = { reasonCode } as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};

			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			// IMPORTANT: binary download
			// Allow caller override, but default to blob if not specified
			if (!localVarRequestOptions.responseType) {
				localVarRequestOptions.responseType = 'blob';
			}

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Get all limitation values by type (admin)
		 * @description Retrieves all available limitation values for the specified type.
		 * @param {LimitationType} type Limitation type
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getAllLimitationValuesByType: async (
			type: LimitationType,
			options: any = {},
		): Promise<RequestArgs> => {
			if (type === null || type === undefined) {
				throw new RequiredError(
					'type',
					'Required parameter type was null or undefined when calling getAllLimitationValuesByType.',
				);
			}

			const localVarPath = `/admin/limitations/values`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = { type } as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Get limitations by sapCode (admin)
		 * @description If sapCode is omitted, backend returns all limitations.
		 * @param {string} [sapCode] Product SAP code
		 * @param {*} [options] Override http request option.
		 */
		getAllLimitationsBySapCode: async (
			sapCode?: string,
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/admin/limitations`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = { sapCode } as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (
					localVarQueryParameter[key] !== undefined &&
					localVarQueryParameter[key] !== null &&
					localVarQueryParameter[key] !== ''
				) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Import limitations from file (multipart/form-data)
		 * @param {File | Blob} file File to upload
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		importLimitations: async (
			file: File | Blob,
			options: any = {},
		): Promise<RequestArgs> => {
			if (file === null || file === undefined) {
				throw new RequiredError(
					'file',
					'Required parameter file was null or undefined when calling importLimitations.',
				);
			}

			const localVarPath = `/admin/limitations`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'POST',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const formData = new FormData();
			formData.append('file', file as any); // <-- change to 'excelFile' if your backend expects that name

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			localVarRequestOptions.data = formData;

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},

		/**
		 *
		 * @summary Remove limitation (admin)
		 * @description Removes a limitation from a product. This endpoint uses DELETE with a JSON body.
		 * @param {LimitationDto} limitation Limitation to remove
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		removeLimitation: async (
			limitation: LimitationDto,
			options: any = {},
		): Promise<RequestArgs> => {
			if (limitation === null || limitation === undefined) {
				throw new RequiredError(
					'limitation',
					'Required parameter limitation was null or undefined when calling removeLimitation.',
				);
			}

			const localVarPath = `/admin/limitations`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'DELETE',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {
				'Content-Type': 'application/json',
			} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			localVarRequestOptions.data = limitation as any;

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Export limitations (admin)
		 * @description Returns an Excel file (xlsx) containing all limitations.
		 * NOTE: This endpoint returns binary content. Use `responseType: 'blob'`.
		 * @param {*} [options] Override http request option.
		 */
		exportLimitations: async (options: any = {}): Promise<RequestArgs> => {
			const localVarPath = `/admin/limitations/export`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			// IMPORTANT: binary download
			if (!localVarRequestOptions.responseType) {
				localVarRequestOptions.responseType = 'blob';
			}

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Export limitations import template (admin)
		 * @description Returns an Excel template (xlsx) for limitations import (Import sheet + values sheets).
		 * NOTE: This endpoint returns binary content. Use `responseType: 'blob'`.
		 * @param {*} [options] Override http request option.
		 */
		exportLimitationsImportTemplate: async (
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/admin/limitations/template`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (localVarQueryParameter[key] !== undefined) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			if (!localVarRequestOptions.responseType) {
				localVarRequestOptions.responseType = 'blob';
			}

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
		/**
		 *
		 * @summary Export products (admin)
		 * @description Returns an Excel file (xlsx) containing products. Optional filter by enabled.
		 * NOTE: This endpoint returns binary content. Use `responseType: 'blob'`.
		 * @param {boolean} [enabled] Optional filter by enabled flag
		 * @param {*} [options] Override http request option.
		 */
		exportProducts: async (
			enabled?: boolean,
			sapCode?: string,
			catalogCode?: string,
			aestheticMotif?: string,
			aestheticLine?: string,
			options: any = {},
		): Promise<RequestArgs> => {
			const localVarPath = `/admin/products/export`;
			const localVarUrlObj = new URL(localVarPath, 'https://example.com');

			let baseOptions;
			if (configuration) baseOptions = configuration.baseOptions;

			const localVarRequestOptions: any = {
				method: 'GET',
				...baseOptions,
				...options,
			};

			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {
				enabled,
				sapCode,
				catalogCode,
				aestheticMotif,
				aestheticLine,
			} as any;

			const queryParameters = new URLSearchParams(localVarUrlObj.search);
			for (const key in localVarQueryParameter) {
				if (
					localVarQueryParameter[key] !== undefined &&
					localVarQueryParameter[key] !== null
				) {
					queryParameters.set(key, String(localVarQueryParameter[key]));
				}
			}
			if (options?.query) {
				for (const key in options.query) {
					queryParameters.set(key, options.query[key]);
				}
			}
			localVarUrlObj.search = new URLSearchParams(queryParameters).toString();

			const headersFromBaseOptions =
				baseOptions && baseOptions.headers ? baseOptions.headers : {};
			const optHeaders = options?.headers ?? {};
			localVarRequestOptions.headers = {
				...localVarHeaderParameter,
				...headersFromBaseOptions,
				...optHeaders,
			};

			if (!localVarRequestOptions.responseType) {
				localVarRequestOptions.responseType = 'blob';
			}

			return {
				url:
					localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
				options: localVarRequestOptions,
			};
		},
	};
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration?: Configuration) {
	return {
		/**
		 *
		 * @summary Import product customer prices from Excel (multipart/form-data)
		 * @param {File | Blob} excelFile Excel file to upload
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async importProductCustomerPrices(
			excelFile: File | Blob,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).importProductCustomerPrices(excelFile, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 *
		 * @summary Get all products (admin)
		 * @description Retrieves the full list of products for admin usage.
		 * @param {boolean} [enabled] Optional filter by enabled flag
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getAllProducts(
			page: number,
			enabled?: boolean,
			sapCode?: string,
			catalogCode?: string,
			aestheticMotif?: string,
			aestheticLine?: string,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<{ items: ProductSize[]; total: number }>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).getAllProducts(
				page,
				enabled,
				sapCode,
				catalogCode,
				aestheticMotif,
				aestheticLine,
				options,
			);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 *
		 * @summary Import products from Excel (admin)
		 * @description Imports products from an Excel file for the selected business unit.
		 * @param {File | Blob} excelFile Excel file to upload
		 * @param {string} businessUnit Business unit identifier (watches | jewels)
		 * @param {boolean} [skipRemove=false] Whether to remove existing products before import
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async importProducts(
			csvFile: File | Blob,
			businessUnit: string,
			skipRemove: boolean = false,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).importProducts(csvFile, businessUnit, skipRemove, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 *
		 * @summary Get orders by reason code (admin)
		 * @description Retrieves exported orders filtered by the specified reason code.
		 * @param {string} reasonCode Reason code to filter orders
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getOrdersByReasonCode(
			reasonCode: string,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<ExportOrderDto[]>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).getOrdersByReasonCode(reasonCode, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Get all sales groups (admin)
		 * @description Retrieves the list of sales groups available in the system.
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getAllSalesGroups(
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<SalesGroupDto[]>
		> {
			const localVarAxiosArgs =
				await AdminApiAxiosParamCreator(configuration).getAllSalesGroups(
					options,
				);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 *
		 * @summary Get customers summary by sales group (admin)
		 * @description Retrieves customers summary filtered by salesGroupCode and optional filters.
		 *
		 * IMPORTANT: this backend endpoint is declared as HttpGet but it expects a body (`[FromBody] CustomerFilter filter`).
		 * This client sends the filter in the request body via axios `data`.
		 *
		 * @param {string} salesGroupCode Sales group code
		 * @param {CustomerFilter} filter Filter object (e.g. BookedForSales, EventId)
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getCustomersSummaryBySalesGroup(
			salesGroupCode: string,
			filter: CustomerFilter,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<CustomerSummary[]>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).getCustomersSummaryBySalesGroup(salesGroupCode, filter, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 *
		 * @summary Get expiring booked-for-sales by sales group (admin)
		 * @description Retrieves booked-for-sales expiring items filtered by salesGroupCode.
		 * @param {string} salesGroupCode Sales group code
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async getExpiringBookedForSalesBySalesGroup(
			salesGroupCode: string,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<BookedForSalesExpiring[]>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).getExpiringBookedForSalesBySalesGroup(salesGroupCode, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Export orders by reason code (admin)
		 * @description Returns an Excel file (xlsx) for orders filtered by reasonCode.
		 * NOTE: This endpoint returns binary content. The request is configured with `responseType: 'blob'`.
		 * @param {string} reasonCode Reason code to filter orders
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		async exportOrdersByReasonCode(
			reasonCode: string,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blob>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).exportOrdersByReasonCode(reasonCode, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
		/**
		 * @summary Get all limitation values by type (admin)
		 */
		async getAllLimitationValuesByType(
			type: LimitationType,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<LimitationValue[]>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).getAllLimitationValuesByType(type, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 * @summary Get limitations by sapCode (admin)
		 */
		async getAllLimitationsBySapCode(
			sapCode?: string,
			options?: any,
		): Promise<
			(
				axios?: AxiosInstance,
				basePath?: string,
			) => AxiosPromise<LimitationDto[]>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).getAllLimitationsBySapCode(sapCode, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		async importLimitations(
			file: File | Blob,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).importLimitations(file, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},

		/**
		 * @summary Remove limitation (admin)
		 */
		async removeLimitation(
			limitation: LimitationDto,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).removeLimitation(limitation, options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Export limitations (admin)
		 * @description Returns an Excel file (xlsx) containing all limitations.
		 * @param {*} [options] Override http request option.
		 */
		async exportLimitations(
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blob>
		> {
			const localVarAxiosArgs =
				await AdminApiAxiosParamCreator(configuration).exportLimitations(
					options,
				);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Export limitations import template (admin)
		 * @description Returns an Excel template (xlsx) for limitations import.
		 * @param {*} [options] Override http request option.
		 */
		async exportLimitationsImportTemplate(
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blob>
		> {
			const localVarAxiosArgs =
				await AdminApiAxiosParamCreator(
					configuration,
				).exportLimitationsImportTemplate(options);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
		/**
		 *
		 * @summary Export products (admin)
		 * @description Returns an Excel file (xlsx) containing products.
		 * NOTE: This endpoint returns binary content. The request is configured with `responseType: 'blob'`.
		 * @param {boolean} [enabled] Optional filter by enabled flag
		 * @param {*} [options] Override http request option.
		 */
		async exportProducts(
			enabled?: boolean,
			sapCode?: string,
			catalogCode?: string,
			aestheticMotif?: string,
			aestheticLine?: string,
			options?: any,
		): Promise<
			(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blob>
		> {
			const localVarAxiosArgs = await AdminApiAxiosParamCreator(
				configuration,
			).exportProducts(
				enabled,
				sapCode,
				catalogCode,
				aestheticMotif,
				aestheticLine,
				options,
			);

			return (
				axiosInst: AxiosInstance = globalAxios,
				basePath: string = BASE_PATH,
			) => {
				const axiosRequestArgs = {
					...localVarAxiosArgs.options,
					url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
				};
				return axiosInst.request(axiosRequestArgs);
			};
		},
	};
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (
	configuration?: Configuration,
	basePath?: string,
	axiosInst?: AxiosInstance,
) {
	return {
		/**
		 *
		 * @summary Import product customer prices from Excel (multipart/form-data)
		 * @param {File | Blob} excelFile Excel file to upload
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		importProductCustomerPrices(
			excelFile: File | Blob,
			options?: any,
		): AxiosPromise<void> {
			return AdminApiFp(configuration)
				.importProductCustomerPrices(excelFile, options)
				.then((request) => request(axiosInst, basePath));
		},

		/**
		 *
		 * @summary Get all products (admin)
		 * @description Retrieves the full list of products for admin usage.
		 * @param {boolean} [enabled] Optional filter by enabled flag
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getAllProducts(
			page: number,
			enabled?: boolean,
			sapCode?: string,
			catalogCode?: string,
			aestheticMotif?: string,
			aestheticLine?: string,
			options?: any,
		): AxiosPromise<{ items: ProductSize[]; total: number }> {
			return AdminApiFp(configuration)
				.getAllProducts(
					page,
					enabled,
					sapCode,
					catalogCode,
					aestheticMotif,
					aestheticLine,
					options,
				)
				.then((request) => request(axiosInst, basePath));
		},

		/**
		 *
		 * @summary Import products from Excel (admin)
		 * @description Imports products from an Excel file for the selected business unit.
		 * @param {File | Blob} excelFile Excel file to upload
		 * @param {string} businessUnit Business unit identifier (watches | jewels)
		 * @param {boolean} [skipRemove=false] Whether to remove existing products before import
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		importProducts(
			csvFile: File | Blob,
			businessUnit: string,
			skipRemove: boolean = false,
			options?: any,
		): AxiosPromise<void> {
			return AdminApiFp(configuration)
				.importProducts(csvFile, businessUnit, skipRemove, options)
				.then((request) => request(axiosInst, basePath));
		},

		/**
		 *
		 * @summary Get orders by reason code (admin)
		 * @description Retrieves exported orders filtered by the specified reason code.
		 * @param {string} reasonCode Reason code to filter orders
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOrdersByReasonCode(
			reasonCode: string,
			options?: any,
		): AxiosPromise<ExportOrderDto[]> {
			return AdminApiFp(configuration)
				.getOrdersByReasonCode(reasonCode, options)
				.then((request) => request(axiosInst, basePath));
		},

		/**
		 *
		 * @summary Get all sales groups (admin)
		 * @description Retrieves the list of sales groups available in the system.
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getAllSalesGroups(options?: any): AxiosPromise<SalesGroupDto[]> {
			return AdminApiFp(configuration)
				.getAllSalesGroups(options)
				.then((request) => request(axiosInst, basePath));
		},

		/**
		 *
		 * @summary Get customers summary by sales group (admin)
		 * @description Retrieves customers summary filtered by salesGroupCode and optional filters.
		 *
		 * IMPORTANT: this backend endpoint is declared as HttpGet but it expects a body (`[FromBody] CustomerFilter filter`).
		 * This client sends the filter in the request body via axios `data`.
		 *
		 * @param {string} salesGroupCode Sales group code
		 * @param {CustomerFilter} filter Filter object (e.g. BookedForSales, EventId)
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getCustomersSummaryBySalesGroup(
			salesGroupCode: string,
			filter: CustomerFilter,
			options?: any,
		): AxiosPromise<CustomerSummary[]> {
			return AdminApiFp(configuration)
				.getCustomersSummaryBySalesGroup(salesGroupCode, filter, options)
				.then((request) => request(axiosInst, basePath));
		},

		/**
		 *
		 * @summary Get expiring booked-for-sales by sales group (admin)
		 * @description Retrieves booked-for-sales expiring items filtered by salesGroupCode.
		 * @param {string} salesGroupCode Sales group code
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getExpiringBookedForSalesBySalesGroup(
			salesGroupCode: string,
			options?: any,
		): AxiosPromise<BookedForSalesExpiring[]> {
			return AdminApiFp(configuration)
				.getExpiringBookedForSalesBySalesGroup(salesGroupCode, options)
				.then((request) => request(axiosInst, basePath));
		},
		/**
		 *
		 * @summary Export orders by reason code (admin)
		 * @description Returns an Excel file (xlsx) for orders filtered by reasonCode.
		 * @param {string} reasonCode Reason code to filter orders
		 * @param {*} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		exportOrdersByReasonCode(
			reasonCode: string,
			options?: any,
		): AxiosPromise<Blob> {
			return AdminApiFp(configuration)
				.exportOrdersByReasonCode(reasonCode, options)
				.then((request) => request(axiosInst, basePath));
		},
		getAllLimitationValuesByType(
			type: LimitationType,
			options?: any,
		): AxiosPromise<LimitationValue[]> {
			return AdminApiFp(configuration)
				.getAllLimitationValuesByType(type, options)
				.then((request) => request(axiosInst, basePath));
		},

		getAllLimitationsBySapCode(
			sapCode?: string,
			options?: any,
		): AxiosPromise<LimitationDto[]> {
			return AdminApiFp(configuration)
				.getAllLimitationsBySapCode(sapCode, options)
				.then((request) => request(axiosInst, basePath));
		},

		importLimitations(file: File | Blob, options?: any): AxiosPromise<void> {
			return AdminApiFp(configuration)
				.importLimitations(file, options)
				.then((request) => request(axiosInst, basePath));
		},

		removeLimitation(
			limitation: LimitationDto,
			options?: any,
		): AxiosPromise<void> {
			return AdminApiFp(configuration)
				.removeLimitation(limitation, options)
				.then((request) => request(axiosInst, basePath));
		},
		/**
		 *
		 * @summary Export limitations (admin)
		 * @description Returns an Excel file (xlsx) containing all limitations.
		 * @param {*} [options] Override http request option.
		 */
		exportLimitations(options?: any): AxiosPromise<Blob> {
			return AdminApiFp(configuration)
				.exportLimitations(options)
				.then((request) => request(axiosInst, basePath));
		},
		/**
		 *
		 * @summary Export limitations import template (admin)
		 * @description Returns an Excel template (xlsx) for limitations import.
		 * @param {*} [options] Override http request option.
		 */
		exportLimitationsImportTemplate(options?: any): AxiosPromise<Blob> {
			return AdminApiFp(configuration)
				.exportLimitationsImportTemplate(options)
				.then((request) => request(axiosInst, basePath));
		},
		/**
		 *
		 * @summary Export products (admin)
		 * @description Returns an Excel file (xlsx) containing products.
		 * @param {boolean} [enabled] Optional filter by enabled flag
		 * @param {*} [options] Override http request option.
		 */
		exportProducts(
			enabled?: boolean,
			sapCode?: string,
			catalogCode?: string,
			aestheticMotif?: string,
			aestheticLine?: string,
			options?: any,
		): AxiosPromise<Blob> {
			return AdminApiFp(configuration)
				.exportProducts(
					enabled,
					sapCode,
					catalogCode,
					aestheticMotif,
					aestheticLine,
					options,
				)
				.then((request) => request(axiosInst, basePath));
		},
	};
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
	/**
	 *
	 * @summary Import product customer prices from Excel (multipart/form-data)
	 * @param {File | Blob} excelFile Excel file to upload
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public importProductCustomerPrices(excelFile: File | Blob, options?: any) {
		return AdminApiFp(this.configuration)
			.importProductCustomerPrices(excelFile, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get all products (admin)
	 * @description Retrieves the full list of products for admin usage.
	 * @param {boolean} [enabled] Optional filter by enabled flag
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public getAllProducts(
		page: number,
		enabled?: boolean,
		sapCode?: string,
		catalogCode?: string,
		aestheticMotif?: string,
		aestheticLine?: string,
		options?: any,
	) {
		return AdminApiFp(this.configuration)
			.getAllProducts(
				page,
				enabled,
				sapCode,
				catalogCode,
				aestheticMotif,
				aestheticLine,
				options,
			)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Import products from Excel (admin)
	 * @description Imports products from an Excel file for the selected business unit.
	 * @param {File | Blob} excelFile Excel file to upload
	 * @param {string} businessUnit Business unit identifier (watches | jewels)
	 * @param {boolean} [skipRemove=false] Whether to remove existing products before import
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public importProducts(
		excelFile: File | Blob,
		businessUnit: string,
		skipRemove: boolean = false,
		options?: any,
	) {
		return AdminApiFp(this.configuration)
			.importProducts(excelFile, businessUnit, skipRemove, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get orders by reason code (admin)
	 * @description Retrieves exported orders filtered by the specified reason code.
	 * @param {string} reasonCode Reason code to filter orders
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public getOrdersByReasonCode(reasonCode: string, options?: any) {
		return AdminApiFp(this.configuration)
			.getOrdersByReasonCode(reasonCode, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get all sales groups (admin)
	 * @description Retrieves the list of sales groups available in the system.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public getAllSalesGroups(options?: any) {
		return AdminApiFp(this.configuration)
			.getAllSalesGroups(options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get customers summary by sales group (admin)
	 * @description Retrieves customers summary filtered by salesGroupCode and optional filters.
	 *
	 * IMPORTANT: this backend endpoint is declared as HttpGet but it expects a body (`[FromBody] CustomerFilter filter`).
	 * This client sends the filter in the request body via axios `data`.
	 *
	 * @param {string} salesGroupCode Sales group code
	 * @param {CustomerFilter} filter Filter object (e.g. BookedForSales, EventId)
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public getCustomersSummaryBySalesGroup(
		salesGroupCode: string,
		filter: CustomerFilter,
		options?: any,
	) {
		return AdminApiFp(this.configuration)
			.getCustomersSummaryBySalesGroup(salesGroupCode, filter, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Get expiring booked-for-sales by sales group (admin)
	 * @description Retrieves booked-for-sales expiring items filtered by salesGroupCode.
	 * @param {string} salesGroupCode Sales group code
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public getExpiringBookedForSalesBySalesGroup(
		salesGroupCode: string,
		options?: any,
	) {
		return AdminApiFp(this.configuration)
			.getExpiringBookedForSalesBySalesGroup(salesGroupCode, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 *
	 * @summary Export orders by reason code (admin)
	 * @description Returns an Excel file (xlsx) for orders filtered by reasonCode.
	 * NOTE: This endpoint returns binary content. The request uses `responseType: 'blob'`.
	 * @param {string} reasonCode Reason code to filter orders
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public exportOrdersByReasonCode(reasonCode: string, options?: any) {
		return AdminApiFp(this.configuration)
			.exportOrdersByReasonCode(reasonCode, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 * @summary Get all limitation values by type (admin)
	 */
	public getAllLimitationValuesByType(type: LimitationType, options?: any) {
		return AdminApiFp(this.configuration)
			.getAllLimitationValuesByType(type, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 * @summary Get limitations by sapCode (admin)
	 * @description If sapCode is omitted, backend returns all limitations.
	 */
	public getAllLimitationsBySapCode(sapCode?: string, options?: any) {
		return AdminApiFp(this.configuration)
			.getAllLimitationsBySapCode(sapCode, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 * @summary Import limitations from file (admin)
	 */
	public importLimitations(file: File | Blob, options?: any) {
		return AdminApiFp(this.configuration)
			.importLimitations(file, options)
			.then((request) => request(this.axios, this.basePath));
	}

	/**
	 * @summary Remove limitation (admin)
	 * @description DELETE with JSON body.
	 */
	public removeLimitation(limitation: LimitationDto, options?: any) {
		return AdminApiFp(this.configuration)
			.removeLimitation(limitation, options)
			.then((request) => request(this.axios, this.basePath));
	}
	/**
	 *
	 * @summary Export limitations (admin)
	 * @description Returns an Excel file (xlsx) containing all limitations.
	 * NOTE: This endpoint returns binary content. The request uses `responseType: 'blob'`.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public exportLimitations(options?: any) {
		return AdminApiFp(this.configuration)
			.exportLimitations(options)
			.then((request) => request(this.axios, this.basePath));
	}
	/**
	 *
	 * @summary Export limitations import template (admin)
	 * @description Returns an Excel template (xlsx) for limitations import.
	 * NOTE: This endpoint returns binary content. The request uses `responseType: 'blob'`.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public exportLimitationsImportTemplate(options?: any) {
		return AdminApiFp(this.configuration)
			.exportLimitationsImportTemplate(options)
			.then((request) => request(this.axios, this.basePath));
	}
	/**
	 *
	 * @summary Export products (admin)
	 * @description Returns an Excel file (xlsx) containing products.
	 * NOTE: This endpoint returns binary content. The request uses `responseType: 'blob'`.
	 * @param {boolean} [enabled] Optional filter by enabled flag
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof AdminApi
	 */
	public exportProducts(
		enabled?: boolean,
		sapCode?: string,
		catalogCode?: string,
		aestheticMotif?: string,
		aestheticLine?: string,
		options?: any,
	) {
		return AdminApiFp(this.configuration)
			.exportProducts(
				enabled,
				sapCode,
				catalogCode,
				aestheticMotif,
				aestheticLine,
				options,
			)
			.then((request) => request(this.axios, this.basePath));
	}
}
